import { Component, Inject, OnInit, QueryList, ViewChildren } from '@angular/core';
import { FormBuilder, FormGroup, UntypedFormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { CommonConfirmationModalData } from 'src/app/components/common/common-confirmation-modal/common-confirmation-modal.component.model';
import { EmailActivityEditorComponent } from 'src/app/components/workflow/activities/email-activity/email-activity-editor/email-activity-editor.component';
import { Section, TargetJurisdictionResources, WorkflowConfigurationSaveAction, WorkflowCopyConfiguration } from 'src/app/models';
import { CustomList } from 'src/app/models/custom-list';
import { EmailFooter } from 'src/app/models/email-footer';
import { FeeRecipient } from 'src/app/models/fee-recipient';
import { WorkflowContextService, WorkflowService } from 'src/app/services';
import { WorkflowJanusService } from '../../../workflow-janus.service';

@Component({
  selector: 'app-import-workflow-modal',
  templateUrl: './import-workflow-modal.component.html',
  styleUrls: ['./import-workflow-modal.component.scss'],
  standalone: false
})

export class ImportWorkflowModalDataComponent implements OnInit {

  @ViewChildren('emailActivityEditors') emailActivityEditors: QueryList<
      EmailActivityEditorComponent
    >;

  WorkflowConfigurationSaveAction = WorkflowConfigurationSaveAction;


  loading = true;
  isSaving = false;

  sourceWorkflowName = '';

  config: WorkflowCopyConfiguration;
  // added by Vipul on 04/19/2026
  finishModal: CommonConfirmationModalData = {
    open: false,
    yesNoBtn: true,
    status: 'info',
    modalWidth: '687px',
    modalHeight: 'auto',
    modalDescp: 'Finish Import Workflow',
  }

  targetResources: TargetJurisdictionResources;
  targetCustomLists: CustomList[] = [];
  targetRoleMemberCustomLists: CustomList[] = [];

  // end by Vipul on 04/19/2026
  workflowSettingsForm!: FormGroup;
  roleMappingsForm!: FormGroup;

  sections: Section[] = [
    {
      key: 'workflow-settings',
      label: 'Review & Edit Workflow Settings',
      enabled: true,
      completed: false
    },
    {
      key: 'roles',
      label: 'Configure Workflow Roles',
      enabled: false,
      completed: false
    },
    {
      key: 'custom-lists',
      label: 'Configure Workflow Custom Lists & Items',
      enabled: false,
      completed: false
    },
    {
      key: 'fee-recipients',
      label: 'Configure Fee Recipients',
      enabled: false,
      completed: false
    },
    {
      key: 'fees',
      label: 'Review & Edit Workflow Fees',
      enabled: false,
      completed: false
    },
    {
      key: 'email-footers',
      label: 'Configure Workflow Email Footers',
      enabled: false,
      completed: false
    },
    {
      key: 'emails',
      label: 'Review & Edit Workflow Emails',
      enabled: false,
      completed: false
    },
    {
      key: 'print-templates',
      label: 'Review & Edit Workflow Print Templates',
      enabled: false,
      completed: false
    },
    {
      key: 'contractors',
      label: 'Configure Contractor Types',
      enabled: false,
      completed: false
    },
    {
      key: 'mapService',
      label: 'Select Map Service',
      enabled: false,
      completed: false
    }
  ];

  expandedIndex = 0;
  customListMappingsForm!: FormGroup;
  customListOptions: any[] = [];

  feeRecipientMappingsForm!: FormGroup;
  feeRecipientOptions: any[] = [];

  feeUpdatesForm!: FormGroup;

  mapServiceForm!: FormGroup;
  mapServiceOptions: any[] = [];

  emailFooterMappingsForm!: FormGroup;
  emailFooterOptions: any[] = [];

  emailUpdatesForm: FormGroup = this.fb.group({});

  printTemplateUpdatesForm: FormGroup = this.fb.group({});

  contractorFormReady = false;
  printTemplateFormReady = false;

  contractorUpdatesForm: UntypedFormGroup;

  emailSections: Section[] = []; // Code Added by Sanchit on 04/16/2026
  expandedEmailSectionIndex = 0; // Code Added by Sanchit on 04/16/2026

  roleOptions: any[] = []; // Code Added by Sanchit on 06/18/2026

  constructor(
    private dialogRef: MatDialogRef<ImportWorkflowModalDataComponent>,
    private fb: FormBuilder,
    private workflowService: WorkflowService,
    private workflowJanusService: WorkflowJanusService,
    private router: Router,
    private _route: ActivatedRoute,
    private _context: WorkflowContextService,
    private _toastrSvc: ToastrService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  get allSectionsCompleted(): boolean {
    return this.sections.every(s => s.enabled ? s.completed : true);
  }

  ngOnInit(): void {
    this.workflowSettingsForm = this.fb.group({
      workflowName: ['', Validators.required],
      description: ['']
    });

    this.roleMappingsForm = this.fb.group({});
    this.customListMappingsForm = this.fb.group({});
    this.feeRecipientMappingsForm = this.fb.group({});
    this.feeUpdatesForm = this.fb.group({});
    this.mapServiceForm = this.fb.group({
      mapServiceTargetId: [null]
    });
    this.emailFooterMappingsForm = this.fb.group({});
    this.emailUpdatesForm = this.fb.group({});
    this.printTemplateUpdatesForm = this.fb.group({});
    this.contractorUpdatesForm = this.fb.group({});

    this.loadWorkflow();
  }

  // Start Code added by Sanchit on 06/22/2026
  loadWorkflow() {
    this.loading = true;
    if (this.data.workflowSaveId) {
      this.workflowService
        .loadSavedWorkflowConfigurationOptions(
          this.data.workflowSaveId
        )
        .subscribe({
          next: (options: any) => {
            this.setConfigurationOptions(options);
            this.loading = false;
          },
          error: () => {
            this.loading = false;
          }
        });
    } else {
      this.workflowService
        .getCopyWorkflowConfigurationOptions(
          this.data.sourceWorkflowId,
          this.data.targetJurisdictionId
        )
        .subscribe({
          next: (options: any) => {
            this.setConfigurationOptions(options);
            this.loading = false;
          },
          error: () => {
            this.loading = false;
          }
        });
    }
  }
  // End Code added by Sanchit on 06/22/2026

  setConfigurationOptions(options: any) {

    this.config = options.sourceWorkflowElements || {};
    this.targetResources = options.targetJurisdictionResources;
    this.targetCustomLists = this.targetResources.customLists?.filter(cl => !cl.roleId) || [];
    this.targetRoleMemberCustomLists = this.targetResources.customLists?.filter(cl => cl.roleId) || [];
    this.sourceWorkflowName = options.originalSourceWorkflowName;
    this.sections[0].completed = this.config.workflowUpdates?.completed;

    // Start Code added by Sanchit on 06/18/2026
    this.roleOptions = (this.targetResources?.responsibleRoles || []).map(
      (role: any) => ({
        label: role.name,
        value: role.id
      })
    );
    // End Code added by Sanchit on 06/18/2026

    if (this.config.roleMappings?.mappings?.length) {

      this.config.roleMappings.mappings.forEach((mapping: any) => {
        this.roleMappingsForm.addControl(
          mapping.sourceRoleId,
          this.fb.control(mapping.targetRoleId || null, Validators.required)
        );
      });

      this.sections[1].enabled = true;
      this.sections[1].completed = this.config.roleMappings.completed;
    }

    if (this.config.customListMappings?.mappings?.length) {

      this.customListMappingsForm = this.fb.group({});

      this.customListOptions = (this.targetResources?.customLists || []).map((list: any) => ({
        label: list.name,
        value: list.id
      }));

      this.config.customListMappings.mappings.forEach((mapping: any) => {
        this.customListMappingsForm.addControl(
          mapping.sourceListId,
          this.fb.control(mapping.targetListId || null, Validators.required)
        );
      });

      this.sections[2].enabled = true;
      this.sections[2].completed = this.config.customListMappings.completed;
    }

    if (this.config.feeRecipientMappings?.mappings?.length) {
      this.feeRecipientMappingsForm = this.fb.group({});

      this.feeRecipientOptions = (this.targetResources?.feeRecipients || []).map((r: any) => ({
        label: r.value,
        value: r.id
      }));

      this.config.feeRecipientMappings.mappings.forEach((mapping: any) => {
        this.feeRecipientMappingsForm.addControl(
          mapping.sourceId,
          this.fb.control(mapping.targetId || null)
        );

        this.feeRecipientMappingsForm.addControl(
          mapping.sourceId + '_ignored',
          this.fb.control(mapping.isIgnored || false)
        );
      });

      this.sections[3].enabled = true;
      this.sections[3].completed = this.config.feeRecipientMappings.completed;
    }

    if (this.config.feeUpdates?.feeDataEntities?.length) {
      this.feeUpdatesForm = this.fb.group({});

      const activities: any[] = [];

      this.config.feeUpdates.feeDataEntities.forEach((fde: any) => {
        const act = fde.parentActivitySurrogate;
        if (act && !activities.some(a => a.id === act.id)) {
          activities.push(act);
        }
      });

      activities.forEach(activity => {
        this.populateDataEntitiesBeforeMeCache(activity);
      });

      this.config.feeUpdates.feeDataEntities.forEach((feeDE: any) => {
        this.feeUpdatesForm.addControl(
          feeDE.templateCode,
          this.fb.group({})
        );
      });

      this.sections[4].enabled = true;
      this.sections[4].completed = this.config.feeUpdates.completed;
    }

    if (this.config.emailFooterMappings?.mappings?.length) {

      this.emailFooterMappingsForm = this.fb.group({});
      this.emailFooterOptions = (this.targetResources?.emailFooters || []).map((f: any) => ({
        label: f.label,
        value: f.id
      }));

      this.config.emailFooterMappings.mappings.forEach((mapping: any) => {
        this.emailFooterMappingsForm.addControl(
          mapping.sourceEmailFooter.id,
          this.fb.group({
            isIgnored: [mapping.isIgnored || false],
            targetId: [mapping.targetId || null, Validators.required]
          })
        );
      });

      this.sections[5].enabled = true;
      this.sections[5].completed = this.config.emailFooterMappings.completed;
    }

    // Start Code Added by Sanchit on 04/16/2026
    if (
      this.config.emailUpdates?.emailActivities &&
      this.config.emailUpdates.emailActivities.length > 0
    ) {
      for (let activity of this.config.emailUpdates.emailActivities) {
        this.emailSections = this.config.emailUpdates.emailSections;

        this.populateDataEntitiesBeforeMeCache(activity);

        this.emailUpdatesForm.addControl(activity.id, new UntypedFormGroup({}));
      }

      this.sections[6].enabled = true;

      this.sections[6].completed = this.config.emailUpdates.completed;
    }
    // Start Code Added by Sanchit on 04/16/2026

    // Start Code Added by Sanchit on 04/15/2026
    if (this.config.printTemplateUpdates?.printTemplateActivities?.length) {

      this.printTemplateUpdatesForm = this.fb.group({});

      this.config.printTemplateUpdates.printTemplateActivities
        ?.filter(a => a && a.id)
        .forEach((activity: any) => {

          this.populateDataEntitiesBeforeMeCache(activity); // keep this

          this.printTemplateUpdatesForm.addControl(
            activity.id,
            this.fb.group({})
          );
        });

      this.sections[7].enabled = true;
      this.sections[7].completed = this.config.printTemplateUpdates.completed;

      setTimeout(() => {
        this.printTemplateFormReady = true;
      });
    }

    if (this.config.selectContractorUpdates) {

      this.contractorUpdatesForm = this.fb.group({});

      this.config.selectContractorUpdates.contractorSelectionActivities
        ?.filter(a => a && a.id)
        .forEach((activity: any) => {
          this.contractorUpdatesForm.addControl(
            activity.id,
            this.fb.group({})
          );
        });

      this.config.selectContractorUpdates.selectContractorDataEntities
        ?.filter(de => de && de.templateCode)
        .forEach((de: any) => {
          this.contractorUpdatesForm.addControl(
            de.templateCode,
            this.fb.group({})
          );
        });

      this.sections[8].enabled = true;
      this.sections[8].completed = this.config.selectContractorUpdates.completed;

      setTimeout(() => {
        this.contractorFormReady = true;
      });
    }
    // End Code Added by Sanchit on 04/15/2026

    if (this.targetResources?.mapServices?.length) {
      this.mapServiceForm = this.fb.group({
        mapServiceTargetId: [
          this.config.mapServiceConfiguration?.targetId || null,
          Validators.required
        ]
      });

      this.mapServiceOptions = this.targetResources.mapServices.map((ms: any) => ({
        label: ms.name,
        value: ms.id
      }));

      this.sections[9].enabled = true;
      this.sections[9].completed = this.config.mapServiceConfiguration?.completed;
    }

    this.loading = false;
  }

  get isContractorFormInvalid(): boolean {
    return this.contractorUpdatesForm
      ? this.contractorUpdatesForm.invalid
      : true;
  }

  getEmailFormGroup(id: string): FormGroup {
    return this.emailUpdatesForm.get(id) as FormGroup;
  }

  updateTargetEmailFooterContent(content: string, sourceEmailFooterId: string) {
    let sourceEmailFooterMapping = this.config.emailFooterMappings.mappings.find(
      efm => efm.sourceEmailFooter.id === sourceEmailFooterId
    );

    sourceEmailFooterMapping.targetEmailFooterContent = content;
  }

  populateDataEntitiesBeforeMeCache(activity: any) {
    this.workflowService.clearDataEntityBeforeMeCache(activity.id);

    this.workflowService
      .getDataEntitiesBeforeMe(
        null,
        activity,
        null,
        [], // or required types if needed
        true,
        this.config.sourceWorkflowVersionId
      )
      .subscribe();
  }

  getRoleOptions() {
    return (this.targetResources?.responsibleRoles || []).map((role:any) => ({
      label: role.name,
      value: role.id
    }));
  }

  nextSection() {
    this.sections[this.expandedIndex].completed = true;

    let next = this.expandedIndex + 1;

    while (
      next < this.sections.length &&
      (!this.sections[next].enabled || this.sections[next].completed)
    ) {
      next++;
    }

    if (next < this.sections.length) {
      this.expandedIndex = next;
    }
    // Start Code added by Sanchit on 06/18/2026
    else {
      // Close the last opened section
      this.expandedIndex = -1;
    }
    // End Code added by Sanchit on 06/18/2026
  }

  // Start code added by Sanchit on 04/16/2026
  updateFeeRecipientUsage() {
    if (this.config.feeUpdates.completed) {
      this.sections[4].completed = false;

      this.config.feeUpdates.completed = false;
    }

    for (let recipientMapping of this.config.feeRecipientMappings.mappings) {
      const removeSourceRecipientFromAvailable = (
        availableFeeRecipients: FeeRecipient[]
      ) => {
        const indexToRemove = availableFeeRecipients.findIndex(
          afr => afr.id === recipientMapping.sourceId
        );

        if (indexToRemove !== -1) {
          availableFeeRecipients.splice(indexToRemove, 1);
        }
      };

      let feeDEsReferencingThisSourceFeeRecipient = this.config.feeUpdates.feeDataEntities.filter(
        feeDE =>
          feeDE.clientFeeRecipient &&
          feeDE.clientFeeRecipient.id === recipientMapping.sourceId
      );

      if (recipientMapping.isIgnored) {
        for (let feeDataEntity of feeDEsReferencingThisSourceFeeRecipient) {
          feeDataEntity.clientFeeRecipient = null;
          removeSourceRecipientFromAvailable(
            feeDataEntity.availableFeeRecipients
          );
        }
      } else {
        if (!recipientMapping.targetId) {

        } else {

          for (let feeDataEntity of feeDEsReferencingThisSourceFeeRecipient) {
            const targetFeeRecipient = this.targetResources.feeRecipients.find(
              fr => fr.id == recipientMapping.targetId
            );

            if (targetFeeRecipient) {
              feeDataEntity.clientFeeRecipient = { ...targetFeeRecipient };
            }

            removeSourceRecipientFromAvailable(
              feeDataEntity.availableFeeRecipients
            );
          }
        }
      }
    }
  }

  updateEmailFooterUsage() {
    if (this.config.emailUpdates.completed) {
      this.sections[6].completed = false;

      this.config.emailUpdates.completed = false;
    }

    for (let footerMapping of this.config.emailFooterMappings.mappings) {
      const removeSourceFooterFromAvailable = (
        availableEmailFooters: EmailFooter[]
      ) => {
        const indexToRemove = availableEmailFooters.findIndex(
          aef => aef.id === footerMapping.sourceEmailFooter.id
        );

        if (indexToRemove !== -1) {
          availableEmailFooters.splice(indexToRemove, 1);
        }
      };

      let emailActivitiesReferencingThisSourceEmailFooter = this.config.emailUpdates.emailActivities.filter(
        ea =>
          ea.model.emailFooterId &&
          ea.model.emailFooterId === footerMapping.sourceEmailFooter.id
      );

      if (footerMapping.isIgnored) {
        for (let emailActivity of emailActivitiesReferencingThisSourceEmailFooter) {
          emailActivity.model.emailFooterId = null;

          removeSourceFooterFromAvailable(emailActivity.model.availableFooters);
        }
      } else {
        if (!footerMapping.targetId) {
          for (let emailActivity of this.config.emailUpdates.emailActivities) {
            let availableFooterFromSource = emailActivity.model.availableFooters.find(
              af => af.id === footerMapping.sourceEmailFooter.id
            );

            if (availableFooterFromSource) {
              availableFooterFromSource.htmlContent =
                footerMapping.targetEmailFooterContent;
            }
          }
        } else {
          for (let emailActivity of emailActivitiesReferencingThisSourceEmailFooter) {
            const targetEmailFooter = this.targetResources.emailFooters.find(
              ef => ef.id == footerMapping.targetId
            );

            if (targetEmailFooter) {
              emailActivity.model.emailFooterId = targetEmailFooter.id;
            }

            removeSourceFooterFromAvailable(
              emailActivity.model.availableFooters
            );
          }
        }
      }

      for (let emailActivityEditor of this.emailActivityEditors) {
        if (
          emailActivitiesReferencingThisSourceEmailFooter.some(
            eartsef => eartsef.id === emailActivityEditor.activity.id
          )
        ) {
          emailActivityEditor.init();
        }
      }
    }
  }

  openEmailDesign(emailActivity: any, event: MouseEvent) {
    event.stopPropagation();

    const url = this.router.createUrlTree(
      [
        '/admin/workflow-builder/readonly',
        emailActivity.workflowId,
        this.config.sourceWorkflowVersionId
      ],
      {
        queryParams: { activityId: emailActivity.id }
      }
    );

    window.open(this.router.serializeUrl(url), '_blank');
  }
  // End code added by Sanchit on 04/16/2026
  //added by Vipul on 04/19/2026

  resetForms() {
    this.workflowSettingsForm.reset();
    this.roleMappingsForm.reset();
    this.customListMappingsForm.reset();
    this.feeRecipientMappingsForm.reset();
    this.feeUpdatesForm.reset();
    this.emailFooterMappingsForm.reset();
    this.emailUpdatesForm.reset();
    this.printTemplateUpdatesForm.reset();
    this.contractorUpdatesForm.reset();
    this.mapServiceForm.reset();
  }
  //end by Vipul on 04/19/2026

  saveForLater() {
    //added by Vipul on 04/19/2026
    if (this.config.feeUpdates?.feeDataEntities?.length > 0) {
      for (let feeDE of this.config.feeUpdates.feeDataEntities) {
        feeDE.parentActivitySurrogate = null;
      }
    }

    this.workflowService
      .saveWorkflowCopyConfiguration(
        this.config,
        this.data.targetJurisdictionId,
        this.data.workflowSaveId
      )
      .subscribe(result => {
        if (result) {
          this.resetForms();
          const parentRoute = this.router.routerState.snapshot.url;
          const segments = parentRoute.split('/').slice(0, -2).filter(Boolean);

          this._toastrSvc.success('Workflow saved successfully!');
          this.close();
          if (segments.length === 5) {
            this.router.navigate([
              '/',
              ...parentRoute.split('/').filter(Boolean)
            ]);
          } else {
            this.router.navigate([
              '/',
              ...segments
            ]);
          }
        } else {
          this._toastrSvc.error(
            'Failed to save settings.  Please contact support if this issue persists.'
          );
        }
      });
      //end by Vipul on 04/19/2026
  }

  finish() {
    //added by Vipul on 04/19/2026
    this.isSaving = true;
    if (this.config.feeUpdates?.feeDataEntities?.length > 0) {
      for (let feeDE of this.config.feeUpdates.feeDataEntities) {
        feeDE.parentActivitySurrogate = null;
      }
    };

    this.workflowService
      .copyWorkflow({
        workflowId: this.data.sourceWorkflowId,
        targetClientId: this.data.targetJurisdictionId,
        configuration: this.config,
        workflowSaveId: this.data.workflowSaveId
      })
      .subscribe(
        newWorkflow => {
          if (newWorkflow) {
            this.resetForms();

            const parentRoute = this.router.routerState.snapshot.url;
            const segments = parentRoute.split('/').slice(0, -2).filter(Boolean);

            this._toastrSvc.success('Workflow imported successfully!');
            this.close();
            if (segments.length === 5) {
              this.router.navigate([
                '/',
                ...parentRoute.split('/').filter(Boolean)
              ]);
            } else {
              this.router.navigate([
                '/',
                ...segments
              ]);
            }
          } else {
            this._toastrSvc.error(
              'Failed to copy/import workflow.  Please contact support if this issue persists.'
            );
          }
          this.isSaving = false;
          this.finishModal.open=false;

        },
        e => {
          this._toastrSvc.error(
            'Failed to copy/import workflow.  Please contact support if this issue persists.'
          );
          this.isSaving = false;
          this.finishModal.open=false;
        }
      );
      //end by Vipul on 04/19/2026
  }

  close() {
    this.workflowJanusService.setNewWorkflowButtonDisabled(false);
    this.dialogRef.close();
  }

  //added by Vipul on 04/19/2026
  openFinishConfirmationModal() {
    this.finishModal = {
      open: true,
      replaceNoWith: 'CANCEL'
    };
  }

  onNameChange(val: string) {
    this.workflowSettingsForm.controls['workflowName'].setValue(val);
  }

  onDescChange(val: string) {
    this.workflowSettingsForm.controls['description'].setValue(val);
  }

  onRoleChange(value: any, mapping: any) {
  // Start Code added by Sanchit on 07/02/2026
  // this.roleMappingsForm.controls[mapping].setValue(value);
    const control = this.roleMappingsForm.get(mapping.sourceRoleId);
    if (control) {
      control.setValue(value);
    }
    mapping.targetRoleId = value;
  // End Code added by Sanchit on 07/02/2026
  }
  //end by Vipul on 04/19/2026
}
